import React from "react";
import { ShareV2 } from "@v2/components/share";

const SharedTryOnV2 = () => {
    return <ShareV2 />;
};

export default SharedTryOnV2;
